import React from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ActionModal from '../common/ActionModal'

const MenuActionModal = ({heading, open, onCancel, cancelButtonText = 'Cancel', buttons, t }) => (
  <ActionModal
    open={open}
    dismissText={t(cancelButtonText)}
    onDismiss={onCancel}
    content={t(heading)}
    buttons={buttons}
  />
)

MenuActionModal.propTypes = {
  cancelButtonText: PropTypes.string,
  heading: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
}

export default translate()(MenuActionModal)


// WEBPACK FOOTER //
// ./src/components/menu/MenuActionModal.js